import React from "react"
import * as s from "./why-choose.module.less"
import * as landingPageStyle from "../landing-page.module.less"
import network from "../../../media/landing-page/network icon.png"
import PaneTitle from "../../pane/pane-title/pane-title";
const WhyChoose = ({
  teamName,
	header,
  backgroundImage
}) => {
  return (
    <div className={ s.whyChoose }>
      <div className={ landingPageStyle.container }>
        <div
          className={ s.leftBox }
          style={ {
            backgroundImage: `url(${backgroundImage})`
          } }
        >
          <div className={ s.overlay }/>
        </div>
        <div className={ s.rightBox }>
          <img alt="network icon" className={ s.networkImg } src={ network }/>
        </div>
        <div className={ s.box }>
          <div className={ s.textBox }>
            <ul>
              <li><strong>Fokus auf Ergebnisse:</strong> Wir liefern funktionierende Prototypen, keine endlosen Konzepte.</li>
              <li><strong>Praxisnahe Expertise:</strong> Jahrelange Erfahrung in der Umsetzung digitaler Produkte.</li>
              <li><strong>Transparenter Prozess:</strong> Sie sind jederzeit über den Fortschritt informiert.</li>
              <li><strong>Direkte Kommunikation:</strong> Sie sprechen direkt mit den Entwicklern und Designern.</li>
            </ul>
          </div>
          <div className={ s.heading }>
            <PaneTitle
                title={header ?? "Warum"}
                description={teamName}
                isWhite
            />
          </div>
        </div>
      </div>
    </div>
  )
}
export default WhyChoose
